import { Component, Input, OnInit } from '@angular/core';
import { CompanyService } from '../../../services/company.service';

import { ICompanyContactLogin } from '../../../models/ICompanyContactLogin.model';
import { AuthService } from '../../../services/auth.service';
import { User, UserType } from '../../../models/User.model';

@Component({
    selector: 'app-my-recruiter',
    templateUrl: './myRecruiter.component.html',
    styleUrls: ['./myRecruiter.component.less']
})
export class MyRecruiterComponent implements OnInit {
    @Input() companyContactId: number;

    private loginInfo: ICompanyContactLogin;
    user: User;
    userType = UserType;

    constructor(
        private company: CompanyService,
        private auth: AuthService
    ) { }

    ngOnInit() {
        this.loginInfo = this.company.getLoginInfo();
        this.user = this.auth.getUser();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/common/myRecruiter/myRecruiter.component.ts